import { useState } from 'react';

import { useSkillSearchQuery } from '@/modules/jobs/queries/useSkillSearchQuery';
import { SkillTypeahead } from '@/modules/jobs/signal/components/SkillTypeahead';

interface SkillSearchInputProps {
  onCommit: (raw: string) => void;
  placeholder: string;
  required?: boolean;
}

/** One typeahead fed by live `/ai/skill-search` results (same wiring as `JobSignalPanel`). */
export function SkillSearchInput({
  onCommit,
  placeholder,
  required,
}: SkillSearchInputProps) {
  const [query, setQuery] = useState('');
  const { data: results = [], isFetching } = useSkillSearchQuery(query);

  return (
    <SkillTypeahead
      // below the query threshold `keepPreviousData` would show the prior query's stale hits
      results={query.trim().length >= 2 ? results : []}
      isLoading={isFetching}
      onQueryChange={setQuery}
      onSelect={onCommit}
      onFreeTextCommit={onCommit}
      placeholder={placeholder}
      required={required}
    />
  );
}
